export default __webpack_public_path__ + "static/media/dropdown_arrow.0fd1b2f5.svg";